import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';

@Component({
  selector: 'app-agencias-admin',
  templateUrl: './agencias-admin.component.html',
  styleUrls: ['./agencias-admin.component.css']
})
export class AgenciasAdminComponent implements OnInit {
  form: FormGroup;
  listAgencias = [];
  cantidad: number;

  constructor(
    private agenciasService:AgenciasService,
    private auxService:AuxiliarService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.cantidad = 0;
    this.form = this.formBuilder.group({
      search: [''],     
    });
    //cargar listado de agencias pendientes
    this.agencias();
  }

  agencias(){ //devuelve una lista con el id y el mombre de la agencia
    this.listAgencias = [];
    this.agenciasService.agenciasFind('1', this.f.search.value).subscribe(data => {
      if(data instanceof HttpResponse) { 
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones       
        this.cantidad = data.body.count;
        this.listAgencias = data.body.list;       
      }    
         
    });       
  }

  get f() { return this.form.controls; }

  onSubmit() { //devuelve una lista con el id y el mombre de la agencia
    this.agencias();       

  }

}
